import React from 'react'

export const Footer = () => {
    return (
        <footer>
            
            <p>&copy; Dorothea Barre &amp; Kristiina Kolu</p>
            <p>Technigo Boot Camp '22, week 9 project</p>
        </footer>
    )
}
